import { MemberDetailsDto } from '../listtones/memberdetailsdto';

export interface EditGroupDto
{
    getMsisdn(): string;
    getGroupId(): number;
    getGroupName(): string;
    getGroupDesc(): string;
    getMemberDetails(): MemberDetailsDto[];
    getToneDetails(): string;
    getLanguage(): string;
    getDeleteMember(): string;
    getPriority(): string;
}

export class EditGroupDtoImpl implements EditGroupDto
{
    private msisdn: string;
    private groupId: number;
    private groupName: string;
    private groupDesc: string;
    private memberDetails: MemberDetailsDto[];
    private toneDetails: string;
    private language: string;
    private deleteMember: string;
    private priority: string;

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string
    {
        return this.msisdn;
    }

    getGroupId(): number
    {
        return this.groupId;
    }
    setGroupId(groupId: number)
    {
        this.groupId = groupId;
    }

    setGroupName(groupName: string)
    {
        this.groupName = groupName;
    } 
    getGroupName(): string 
    {
        return this.groupName;
    }

    setGroupDesc(groupDesc: string)
    {
        this.groupDesc = groupDesc;
    } 
    getGroupDesc(): string 
    {
        return this.groupDesc;
    }

    setMemberDetails(memberDetails: MemberDetailsDto[])
    {
        this.memberDetails = memberDetails;
    }
    getMemberDetails(): MemberDetailsDto[] 
    {
        return this.memberDetails;
    }   

    setToneDetails(toneDetails: string)
    {
        this.toneDetails = toneDetails;
    }
    getToneDetails(): string 
    {
        return this.toneDetails;
    } 

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }   

    setDeleteMember(deleteMember: string)
    {
        this.deleteMember = deleteMember;
    }
    getDeleteMember(): string 
    {
        return this.deleteMember;
    }   

    setPriority(priority: string)
    {
        this.priority = priority;
    }
    getPriority(): string 
    {
        return this.priority;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/editgroup/editgroupdto.ts